import React, { useState, useRef, useEffect } from "react";
import { Col, Container, Row, InputGroup, FormControl, ListGroup } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";

const MyHeaderMob = (props) => {
    const [isScrolled, setIsScrolled] = useState(false);
    const [userData, setUserData] = useState(null);
    const [jwtTokenJobcritic, setjwtTokenJobcritic] = useState(localStorage.getItem("jwt_token_jobcritic"));
    const [searchQuery, setSearchQuery] = useState(''); // Added state for search query
    const navigate = useNavigate();
    const [showSearchBar, setShowSearchBar] = useState(false);
    const [showDropdown, setShowDropdown] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState("Name");
    const location = useLocation();
     const dropdownRef = useRef(null);

    // New function to handle search
    const handleSearch = () => {
        if (searchQuery.trim()) {
            let categoryValue = selectedCategory.toLowerCase();
            if (selectedCategory === "School/College") {
                categoryValue = "school";
            }
            navigate(`/search-employee?query=${encodeURIComponent(searchQuery)}&category=${encodeURIComponent(categoryValue)}`);
            setSearchQuery('');
        }
    };

    // Handle Enter key press
    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            handleSearch();
        }
    };
     useEffect(() => {
       const handleClickOutside = (event) => {
         if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
           setShowDropdown(false);
         }
       };
   
       document.addEventListener("mousedown", handleClickOutside);
   
       const handleScroll = () => {
         setIsScrolled(window.scrollY > 27);
         const scrollY = window.scrollY;
         if (location.pathname === "/verifications") {
           setShowSearchBar(scrollY >= 180);
         }
         setShowDropdown(false);
       };
       window.addEventListener("scroll", handleScroll);
   
       return () => {
         document.removeEventListener("mousedown", handleClickOutside);
         window.removeEventListener("scroll", handleScroll);
       };
     }, [location.pathname, showDropdown]);

    const isDisabled = location.pathname === '/business-form';
    return (

        <>
            {/* <Container>
                <Row className="justify-center"> */}

            {/* Logo */}

            {jwtTokenJobcritic && (location.pathname !== '/verifications' || showSearchBar) && (
                <Col xs={12} className="justify-end pe-0 flex items-center  xs:!w-[100%] !pl-0 ">
                    {/* Search Input */}

                    <div className="w-[100%] flex rounded-full shadowla bg-white relative overflow-visible leading-[1.7]">
                                {/* Search */}
                                <div className="flex-1 relative">
                                    <input
                                        type="text"
                                        placeholder="Search To Reviews"
                                        value={searchQuery}
                                        onChange={(e) => !isDisabled && setSearchQuery(e.target.value)}
                                        onKeyDown={isDisabled ? undefined : handleKeyPress}
                                        className={`w-full pl-[3.5rem] pr-4 py-2 text-sm text-gray-700 placeholder-gray-400 rounded-l-full custom-placeholder ${isDisabled ? 'bg-gray-100 cursor-not-allowed' : ''
                                            }`}
                                        disabled={isDisabled}
                                    />
                                    <div className="absolute inset-y-0 left-[1.5rem] flex items-center pointer-events-none">
                                        <svg
                                            viewBox="0 0 24 24"
                                            width="20px"
                                            height="20px"
                                            className="text-gray-400"
                                            fill="currentColor"
                                        >
                                            <path
                                                fillRule="evenodd"
                                                clipRule="evenodd"
                                                d="M10.12 4.14a5.99 5.99 0 1 0 0 11.98 5.99 5.99 0 0 0 0-11.98m-7.49 5.99a7.49 7.49 0 1 1 13.299 4.728L21.37 20.3l-1.06 1.061-5.44-5.44A7.49 7.49 0 0 1 2.63 10.13"
                                            />
                                        </svg>
                                    </div>
                                </div>

                                {/* Dropdown */}
                                <hr className="h-[24px] border border-[#caccd4] relative top-[7px]" />
                                <div
                                    className={`relative flex items-center justify-between px-4 py-2 rounded-r-full w-[35%] md:w-[43%] xs:w-[32%] ${isDisabled ? 'bg-gray-100 cursor-not-allowed' : ''
                                        }`}
                                    onClick={() => !isDisabled && setShowDropdown(!showDropdown)}
                                    ref={dropdownRef}
                                >
                                    <span className="text-[13px] font-medium text-[#757575]">{selectedCategory}</span>
                                    <svg
                                        className="w-4 h-4 ml-2 text-gray-500"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth={2}
                                        viewBox="0 0 24 24"
                                    >
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                                    </svg>

                                    {showDropdown && (
                                        <ul className="absolute top-full right-0 mt-2 w-60 bg-white border border-gray-200 shadow-xl rounded-xl text-sm z-[9999] py-2">
                                            {['Name', 'Contact', 'Company', 'School/College', 'Location'].map((item) => (
                                                <li
                                                    key={item}
                                                    className={`px-4 py-2 hover:bg-gray-100 cursor-pointer ${item === selectedCategory ? 'font-semibold text-gray-600' : ''
                                                        }`}
                                                    onClick={() => {
                                                        setSelectedCategory(item);
                                                        setShowDropdown(false);
                                                    }}
                                                >
                                                    {item}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            </div>
                </Col>
            )}
            {/* </Row>
            </Container> */}
        </>
    );
};

export default MyHeaderMob;
